import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { EditPositionPreferencesSection } from '../edit-position-preferences-section/edit-position-preferences-section.component';
import STRING_KEYS from '../../../../language/keys';
import { EducationType } from '../../../../modules/create-position/enums/create-position-education.enums';
import {
  DEFAULT_JOB_REQUIREMENT_ID,
  EditJobRequirement,
} from '../../../../modules/application/components/match-tune/edit-job-requirement/edit-job-requirement.component';

const DEGREE_TITLE_MAP: { [key: string]: string } = {
  MASTER: 'Master',
  BACHELOR: 'Bachelor',
  PHD: 'Phd',
};

export const FieldsOfStudySection = ({
  degrees,
  fieldsOfStudy,
  changeHandler,
}: FieldsOfStudySectionProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const degreesItems: PositionJobRequirementState[] = useMemo(() => {
    return ['MASTER', 'BACHELOR', 'PHD'].map((degree) => ({
      id: DEFAULT_JOB_REQUIREMENT_ID,
      type: EducationType.Degree,
      title: DEGREE_TITLE_MAP[degree],
      selected: degrees?.some((degreeState) => degreeState.title === degree),
    }));
  }, [degrees]);

  return (
    <EditPositionPreferencesSection
      emoji="🎓"
      title={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.DEGREE_OR_FIELD_OF_STUDY) }
    >
      <EditJobRequirement
        selectedJobRequirements={ (degreesItems).concat(fieldsOfStudy || []) }
        setSelectedJobRequirementsHandler={ (requirements) => {
          const degreesArray: PositionJobRequirementState[] = [];
          const fieldsOfStudyArray: PositionJobRequirementState[] = [];
          requirements.forEach((requirement) => {
            if (requirement.type === EducationType.Degree) {
              if (requirement.selected) {
                requirement.title = requirement.title.toUpperCase();
                degreesArray.push(requirement);
              }
            } else {
              fieldsOfStudyArray.push(requirement);
            }
          });

          changeHandler(degreesArray, fieldsOfStudyArray);
        } }
      />
    </EditPositionPreferencesSection>
  );
};
